/** Full-column backgrounds for Raise the Sail rating grid (matches Bootstrap alert tints) */
export const RATING_COLUMN_STYLES = {
  green: { cell: '#d4edda', header: '#c3e6cb' },
  yellow: { cell: '#fff3cd', header: '#ffe69c' },
  red: { cell: '#f8d7da', header: '#f5c6cb' },
  na: { cell: '#e9ecef', header: '#dee2e6' },
};

export const RATING_KEYS = ['green', 'yellow', 'red', 'na'];

export const RATING_COLUMN_LABEL = {
  green: 'Green',
  yellow: 'Yellow',
  red: 'Red',
  na: 'N/A',
};

export const RATING_ARIA_LABEL = {
  green: 'Green rating',
  yellow: 'Yellow rating',
  red: 'Red rating',
  na: 'Not applicable',
};

export const RATING_SHORT_LABEL = {
  green: 'G',
  yellow: 'Y',
  red: 'R',
  na: 'NA',
};
